import {
  School as SchoolIcon,
  CalendarMonth,
  ClassOutlined,
  GradeOutlined,
  MenuBook,
  AssignmentOutlined,
  AccountTree,
  Assignment,
  PersonAddAlt,
  Settings as SettingsIconAlt,
  Assessment,
} from '@mui/icons-material';
import { RESOURCES, ACTIONS } from '../../../hooks/useAccessControl';

export const academicMenu = {
  id: 'academic',
  label: 'Academic Management',
  icon: SchoolIcon,
  children: [
    {
      type: 'group',
      id: 'academic-foundation',
      label: 'Core Academic Entities',
      children: [
        { id: 'academic-levels', label: 'Levels', icon: GradeOutlined, permission: { resource: RESOURCES.ACADEMIC.LEVELS, action: ACTIONS.READ } },
        { id: 'academic-classes', label: 'Classes / Streams', icon: ClassOutlined, permission: { resource: RESOURCES.ACADEMIC.CLASSES, action: ACTIONS.READ } },
        { id: 'academic-subjects', label: 'Subjects', icon: MenuBook, permission: { resource: RESOURCES.REPORT_CARD.SUBJECTS, action: ACTIONS.READ } },
        { id: 'academic-subject-with-papers', label: 'Quick Add Subject', icon: MenuBook, permission: { resource: RESOURCES.REPORT_CARD.SUBJECTS, action: ACTIONS.CREATE } },
        { id: 'academic-subject-papers', label: 'Subject Papers', icon: AssignmentOutlined, permission: { resource: RESOURCES.REPORT_CARD.SUBJECT_PAPERS, action: ACTIONS.READ } },
        { id: 'academic-curriculum', label: 'Curriculum', icon: AccountTree, permission: { resource: RESOURCES.REPORT_CARD.CLASS_STREAM_PAPERS, action: ACTIONS.READ } },
      ],
    },
    {
      type: 'group',
      id: 'academic-assignments',
      label: 'Academic Assignments',
      children: [
        { id: 'academic-subject-allocations', label: 'Teacher-Subject Assignments', icon: Assignment, permission: { resource: RESOURCES.REPORT_CARD.SUBJECT_TEACHER_ALLOCATIONS, action: ACTIONS.READ } },
        { id: 'academic-class-allocations', label: 'Class-Teacher Assignments', icon: PersonAddAlt, permission: { resource: RESOURCES.REPORT_CARD.CLASS_TEACHER_ALLOCATIONS, action: ACTIONS.READ } },
      ],
    },
    {
      type: 'group',
      id: 'academic-configuration',
      label: 'Academic Configuration',
      children: [
        { id: 'academic-terms', label: 'Term / Semester Definitions', icon: CalendarMonth, permission: { resource: RESOURCES.ACADEMIC.TERMS, action: ACTIONS.READ } },
        { id: 'assessments-types', label: 'Assessment Types', icon: AssignmentOutlined, permission: { resource: RESOURCES.ASSESSMENTS.TYPES, action: ACTIONS.READ } },
        { id: 'assessments-configurations', label: 'Assessment Configuration', icon: SettingsIconAlt, permission: { resource: RESOURCES.ASSESSMENTS.CONFIGURATIONS, action: ACTIONS.READ } },
        { id: 'grading-scales', label: 'Grading Scales', icon: Assessment, permission: { resource: RESOURCES.REPORT_CARD.GRADING, action: ACTIONS.READ } },
        { id: 'grading-boundaries', label: 'Grade Boundaries', icon: GradeOutlined, permission: { resource: RESOURCES.REPORT_CARD.GRADING, action: ACTIONS.READ } },
        { id: 'grading-class-scales', label: 'Class Grading', icon: ClassOutlined, permission: { resource: RESOURCES.REPORT_CARD.GRADING, action: ACTIONS.READ } },
      ],
    },
  ],
};
